import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class GoalList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: [],
      // user: {},
      // updated: false,
      // searched: false,
      loading: true
    };

    this.error = this.error.bind(this);
    this.insertObjectives = this.insertObjectives.bind(this);
    this.deleteObjectives = this.deleteObjectives.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  insertObjectives() {
    this.props.history.push("/objective/form");
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.handleObjectives();
  }

  handleObjectives() {
    axios
      .get(`${URL.api}classification/objective/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({
            list: resp.data.data,
            loading: false
          });
        },
        error => {
          this.error("Não foi possível listar os objetivos");
        }
      );
  }

  deleteObjectives(rows) {
    const obj = {
      objectives: rows
    };

    axios
      .post(`${URL.api}classification/objective/deleteMany`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.handleObjectives();
        },
        () => {
          this.error("Não foi possível apagar os objetivos");
        }
      );
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.state.loading ? (
          <Loading />
        ) : (
          <Row>
            <Breadcrumb current={this.props.currentRoute} />
            {this.state.list ? (
              <div id="list">
                <DataTable
                  list={this.state.list}
                  path="/objective/edit/"
                  title="Objetivos"
                  header={[
                    { name: "id", denomination: "ID" },
                    { name: "description", denomination: "Descrição" },
                    { name: "order", denomination: "Ordem" },
                    {
                      name: "thematic_unit_id",
                      denomination: "Unidade Temática"
                    }
                  ]}
                  insert
                  delete
                  insertAction={this.insertObjectives}
                  deleteAction={this.deleteObjectives}
                />
              </div>
            ) : (
              <Loading />
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(GoalList);
